import Immutable from 'immutable'
import moment from 'moment'

import createRelationship from './Relationship'

export const UserRecord = Immutable.Record({
  date_of_birth: '',
  email: '',
  first_name: '',
  last_name: '',
  id: null,
  lastLogin: null,
  numbers: Immutable.Set(),
  relationships: Immutable.Set(),
  roles: Immutable.Set(),
}, 'User')

export const UserFilterRecord = Immutable.Record({
  clientId: null,
}, 'UserFilter')

export default function createUserRecord({
  date_of_birth,
  last_login: lastLogin,
  numbers,
  relationships = [],
  roles,
  ...user
}) {
  return new UserRecord({
    ...user,
    // eslint-disable-next-line camelcase
    date_of_birth: date_of_birth ? moment(date_of_birth) : null,
    lastLogin: lastLogin ? moment(lastLogin) : null,
    numbers: Immutable.Set(numbers),
    relationships: Immutable.Set(relationships).map(r => createRelationship({
      ...r,
      user,
    })),
    roles: Immutable.Set(roles),
  })
}

export function createUserFromCreator(creatorObj) {
  if (!creatorObj.creator) {
    return null
  }

  return createUserRecord({
    ...creatorObj.creator,
  })
}

export function createUserFromRelationship({ user, ...relationship }) {
  return createUserRecord({
    ...user,
    relationships: [relationship],
  })
}

export function createUserFromUser(user) {
  return createUserRecord(user)
}

export function filterUser(filter, user) {
  let pass = true

  if (!filter) {
    return pass
  }

  if (filter.clientId) {
    pass = user.relationships.some(r => r.client_id === filter.clientId)
  }

  return pass
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/User.js